import DraggableWallResizer from './DraggableWallResizer';
import * as PIXI from 'pixi.js';
import { isMobile } from '../../util/userAgent';

const WIDTH = 2;
const COLOR = 0x0058a3;
const HIT_AREA_SCALE = 25;

export default class DragLine extends DraggableWallResizer {
  constructor(args) {
    super(args);

    this.dragLine = null;
    this.points = args.points;

    this.dragLine = new PIXI.Graphics();
    this.dragLine.cursor = this.getHoverCursor();
    this.dragLine.lineStyle(WIDTH, COLOR);
    this.x = args.points[0].x;
    this.y = args.points[0].y;
    this.dragLine.moveTo(args.points[0].x, args.points[0].y);
    this.dragLine.lineTo(args.points[1].x, args.points[1].y);

    this.dragLine.hitArea = this.getHitArea();

    this.dragLine.on('pointerup', this.onPointerUp);
    this.dragLine.on('pointerupoutside', this.onPointerUp);
    this.dragLine.on('pointermove', this.onPointerMove);
    this.dragLine.on('pointerdown', this.onPointerDown);

    this.dragLine.interactive =
      !isMobile() && (this.moveableAxes.x || this.moveableAxes.y);
  }

  update({ points, prevWallSize }) {
    super.update({ prevWallSize });
    this.dragLine.clear();

    this.dragLine.lineStyle(WIDTH, COLOR);
    this.x = points[0].x;
    this.y = points[0].y;
    this.dragLine.moveTo(points[0].x, points[0].y);
    this.dragLine.lineTo(points[1].x, points[1].y);

    this.dragLine.hitArea = this.getHitArea();
  }

  getHoverCursor() {
    return this.moveableAxes.y ? 'ns-resize' : 'ew-resize';
  }

  getHitArea() {
    const hitArea = this.dragLine.getBounds();
    if (this.moveableAxes.x) {
      hitArea.width *= HIT_AREA_SCALE;
      hitArea.x -= hitArea.width / 2;
    } else if (this.moveableAxes.y) {
      hitArea.height *= HIT_AREA_SCALE;
      hitArea.y -= hitArea.height / 2;
    }
    return hitArea;
  }

  getPosition() {
    return { x: this.x, y: this.y };
  }

  getDisplayObject() {
    return this.dragLine;
  }

  destroy() {
    this.dragLine.off('pointermove');
    this.dragLine.off('pointerdown');
    this.dragLine.off('pointerup');
    this.dragLine.off('pointerupoutside');

    this.dragLine && this.dragLine.destroy();
  }
}
